var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTimeInterval(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.5 8.60417L14.9776 10.1875L13.4543 8.60417M15.1638 9.79167C15.1914 9.53174 15.2056 9.26759 15.2056 9C15.2056 5.06497 12.1375 1.875 8.35281 1.875C4.56811 1.875 1.5 5.06497 1.5 9C1.5 12.935 4.56811 16.125 8.35281 16.125C10.5056 16.125 12.4265 15.0929 13.6828 13.4787M8.35281 5.04167V9L10.6371 10.5833",
    stroke: "black",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTimeInterval);
export default __webpack_public_path__ + "static/media/time-interval.204d4639d01e075099d6ac59174da3c4.svg";
export { ForwardRef as ReactComponent };